<template>
  <div>
    <div v-if="props.label" class="text-lg font-bold">
      {{ props.label }}
    </div>
    <div
      :class="{
        ['line-clamp-5']: props.miniMode
      }"
    >
      <slot></slot>
    </div>
    <button v-if="props.miniMode" @click="emit('read-full')" class="text-blue-600">
      Читать далее
    </button>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  label?: string
  miniMode?: boolean
}>()
const emit = defineEmits<{
  (e: 'read-full'): void
}>()
</script>
